export function variantMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      variantId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}


export function variantMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, variantId: json.result.objectId}
  };
}

export function fixCreateVariantId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixUpdateVariantId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyVariants(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      variantId: resource.objectId,
    })),
  };
}